import Reflux from 'reflux';
import NotificationDetailActions from 'actions/NotificationDetail';
import SteelCompass from 'services/SteelCompass';
// import { normalize, Schema, arrayOf } from 'normalizr';
import { notificationPageLength } from 'Constants';

import { normalize, Schema, arrayOf } from 'normalizr';
const notification = new Schema('notification');

const NotificationDetailStore = Reflux.createStore({
  listenables: [NotificationDetailActions],
  data: {
    notifications: {
      pageStart: 0,
      pageLength: notificationPageLength,
      loading: true,
    },
    list: {
      notifications: [],
    },
    entities: {
      notification: {},
    },
  },
  getInitialState() {
    return this.data;
  },
  read(includedRead) {
    const { pageStart } = this.data.notifications;
    this.getNotificationsAtPage(pageStart, includedRead);
  },
  getNotificationsAtPage(pageStart, includedRead) {
    const { pageLength } = this.data.notifications;
    if (pageStart + pageLength < this.data.list.notifications.length) {
      this.data = {
        ...this.data,
        notifications: {
          ...this.data.notifications,
          pageStart,
        },
      };
      this.trigger(this.data);
      return;
    }
    this.data = {
      ...this.data,
      notifications: {
        ...this.data.notifications,
        loading: true,
      },
    };
    this.trigger(this.data);
    return SteelCompass.request(
      'notifications',
      'read',
      { reversed: false, includeRead: includedRead, types: [] },
      pageStart,
      pageLength
    ).then((response) => {
      const data = normalize(response, arrayOf(notification));
      const { entities } = this.data;
      const notifications =
        pageStart === 1
          ? data.result
          : this.data.list.notifications.concat(data.result);
      this.data = {
        ...this.data,
        notifications: {
          ...this.data.notifications,
          pageStart,
          loading: false,
        },
        entities: {
          ...entities,
          notification: {
            ...entities.notification,
            ...data.entities.notification,
          },
        },
        list: {
          ...this.data.list,
          notifications,
        },
      };
      this.trigger(this.data);
    });
  },
  nextNotifications() {
    this.getNotificationsAtPage(
      this.data.notifications.pageStart + this.data.notifications.pageLength
    );
  },
  prevNotifications() {
    if (
      this.data.notifications.pageStart >= this.data.notifications.pageLength
    ) {
      this.getNotificationsAtPage(
        this.data.notifications.pageStart - this.data.notifications.pageLength
      );
    }
  },
});

export default NotificationDetailStore;



// WEBPACK FOOTER //
// ./src/js/stores/NotificationDetail.js